import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Dashboard.css";
import logo from "../assets/66826e00fddae23ee8d69cb6217278d46a998ae6.png";
import logout from "../assets/logout.svg";
import userIcon from "../assets/5400308.png";

const Header: React.FC = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState<string>("");
  useEffect(() => {
    const userData = localStorage.getItem("gp_user");
    
    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        
        setUserName(parsedUser.name || parsedUser.username || "User");
      } catch (error) {
        console.error("Invalid user JSON", error);
      }
    } else {
      console.log("No user data found in localStorage");
    }
  }, []);

  const handleLogout = () => {
    // Clear all authentication data
    localStorage.removeItem("authToken");
    localStorage.removeItem("auth");
    localStorage.removeItem("gp_token");
    localStorage.removeItem("gp_phone");
    localStorage.removeItem("gp_user");

    navigate("/");
    window.location.reload();
  };

  return (
    <div className="header-set">
      <header className="header">
        {/* Left Logo */}
        <div className="branding">
          <img src={logo} alt="logo" className="logo" />
        </div>

        {/* Right Side: User name + Logout Button */}
        <div className="user-section">
          {/* User Name with Icon */}
          <div className="user-info">
            <img src={userIcon} alt="user" className="user-icon" />
            <span className="user-name">Welcome, {userName}</span>
          </div>

          {/* Logout Button */}
          <button className="logout-btn" onClick={handleLogout}>
            <img src={logout} alt="logout-icon" className="logout-svg-icon" />
            Logout
          </button>
        </div>
      </header>
    </div>
  );
};

export default Header;